module.exports = __webpack_public_path__ + "static/media/slider_digital.43576460.jpg";